import React from 'react';
import * as Styled from './CardContent.styled';

/**
 * `CardContent` wraps components supplied to `Card`
 *  It controls styling of the content such as padding
 */
const CardContent = (props) => <Styled.CardContent {...props} />;
export default CardContent;
